import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, DropdownButton, Dropdown } from 'react-bootstrap';
import { StorageUnit } from '../types';
import {toast} from 'react-toastify';
import { createStorageUnit,updateStorageUnit,deleteStorageUnit } from '../../../../../crud/management_api/storage_units';
import MiniLoadingSpinner from '../../../../../components/Spinners/MiniLoadingSpinner';
import { getProductStockByLocalId } from '../../../../../crud/management_api/stock_management';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import { FaInfoCircle, FaLayerGroup, FaWarehouse } from 'react-icons/fa'
import SearchDropdown from '../../../../../components/common/SearchDropdown/SearchDropdown';

interface ModalProps {
  show: boolean;
  parentUnit?: StorageUnit;
  handleClose: () => void;
  units: StorageUnit[];
  setUnits: (newUnits: StorageUnit[]) => void;
}

export const RenderCreateUnitModal: React.FC<ModalProps> = ({
    show,
    parentUnit,
    units,
    handleClose,
    setUnits,
  }) => {
    const [name, setName] = useState('');
    const [priority, setPriority] = useState(1);
    const [backupUnitId, setBackupUnitId] = useState<number | null>(null);
    const [isDefault, setIsDefault] = useState(false);
    const [isGlobal, setIsGlobal] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = () => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        const localId = user ? Number(user.local_id) : 0;
      const newUnit: StorageUnit = {
        storage_unit_id: 1, // Mock ID
        local_id: parentUnit?.local_id || localId,
        company_id: parentUnit?.company_id || 0,
        is_global: isGlobal,
        is_default: isDefault,
        name,
        priority,
        backup_storage_unit_id: parentUnit?.storage_unit_id || backupUnitId,
      };
      createStorageUnit(newUnit).then((res: any) => {
        const newUnits = [...units, res.data];
        setUnits(newUnits);
        handleClose();
        toast.success('Unidad creada con éxito');
      }).catch((error) => {
        console.error('Error creating storage unit: ', error);
        toast.error(error.response?.data?.message || 'Error creando la unidad');
      }).finally(() => setLoading(false));

    };
  
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">Crear Unidad</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
        {loading && <MiniLoadingSpinner />}
        {!loading &&
          <Form>
            <Form.Group className="mp-formgroup horizontal">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese el nombre"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mp-formgroup horizontal">
              <Form.Label>Prioridad</Form.Label>
              <Dropdown className="user-dropdown-container">
                <Dropdown.Toggle
                  variant="none"
                  className="user-dropdown"
                  id="priority-dropdown"
                >
                  Prioridad {priority}
                </Dropdown.Toggle>
                <Dropdown.Menu className="user-dropdown-menu">
                  {[...Array(10)].map((_, index) => (
                    <Dropdown.Item
                      key={index + 1}
                      onClick={() => setPriority(index + 1)}
                      active={priority === index + 1}
                    >
                      <div className="user-item">
                        <FaLayerGroup size={16} />
                        <span className="user-name">Prioridad {index + 1}</span>
                      </div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>
{!parentUnit && (
  <Form.Group className="mp-formgroup horizontal">
    <Form.Label>Unidad de Respaldo</Form.Label>
    <Dropdown className="user-dropdown-container">
      <Dropdown.Toggle
        variant="none"
        className="user-dropdown"
        id="backup-unit-dropdown"
      >
        {backupUnitId
          ? units.find(u => u.storage_unit_id === backupUnitId)?.name
          : 'Ninguno'}
      </Dropdown.Toggle>
      <Dropdown.Menu className="user-dropdown-menu">
        <Dropdown.Item
          onClick={() => setBackupUnitId(null)}
          active={backupUnitId === null}
        >
          <div className="user-item">
            <FaWarehouse size={16} />
            <span className="user-name">Ninguno</span>
          </div>
        </Dropdown.Item>
        {units.map((unit) => (
          <Dropdown.Item
            key={unit.storage_unit_id}
            onClick={() => setBackupUnitId(unit.storage_unit_id)}
            active={backupUnitId === unit.storage_unit_id}
          >
            <div className="user-item">
              <FaWarehouse size={16} />
              <span className="user-name">{unit.name}</span>
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </Form.Group>
)}

            <Form.Group controlId="is_default" className='mp-formgroup horizontal'>
              <Form.Check
                type="checkbox"
                label="Unidad por defecto"
                className="mediopunto-form-check-input"
                name="is_default"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="is-default-tooltip">
                    La unidad será global, es decir, sin otra unidad de almacenamiento de respaldo. 
                  </Tooltip>
                }
              >
                <span style={{color: '#6b6b6b', cursor: 'pointer', marginLeft: '8px'}}>
                  <FaInfoCircle />
                </span>
              </OverlayTrigger>
            </Form.Group>
            <Form.Group controlId="is_global" className='mp-formgroup horizontal'>
                      <Form.Check
                        type="checkbox"
                        label="Almacenamiento Multi-Local"
                        className="mediopunto-form-check-input"
                        name="is_global"
                        checked={isGlobal}
                        onChange={(e) => setIsGlobal(e.target.checked)}
                      />
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="is-global-tooltip">
                          Permite que esta unidad de almacenamiento sea utilizada en múltiples locales.
                        </Tooltip>
                      }
                    >
                      <span style={{color: '#6b6b6b', cursor: 'pointer', marginLeft: '8px'}}>
                        <FaInfoCircle />
                      </span>
                    </OverlayTrigger>
                    </Form.Group>
          </Form>
        }
        </Modal.Body>
        <Modal.Footer>
          <div className="form-modal-footer-custom">
            <Button variant="none" className="form-button-cancel" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="none" className="form-button-create" onClick={handleSubmit}>
              Crear
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  export const RenderEditUnitModal: React.FC<ModalProps> = ({
    show,
    parentUnit: unitToEdit,
    units,
    handleClose,
    setUnits,
  }) => {
    // States for editing unit details
    const [name, setName] = useState(unitToEdit?.name || '');
    const [priority, setPriority] = useState(unitToEdit?.priority || 1);
    const [backupUnitId, setBackupUnitId] = useState<number | null>(
      unitToEdit?.backup_storage_unit_id || null
    );
    const [isGlobal, setIsGlobal] = useState(unitToEdit?.is_global || false);
    const [isDefault, setIsDefault] = useState(unitToEdit?.is_default || false);
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
      if (!unitToEdit) return;
        setLoading(true);
  
      const updatedUnit: StorageUnit = {
        ...unitToEdit,
        name,
        priority,
        backup_storage_unit_id: backupUnitId,
        is_global: isGlobal,
        is_default: isDefault,
      };

        updateStorageUnit(unitToEdit.storage_unit_id!,updatedUnit).then((res) => {
            const updatedUnits = units.map((unit) =>
                unit.storage_unit_id === unitToEdit.storage_unit_id ? updatedUnit : unit
              );
          
              setUnits(updatedUnits);
              handleClose();
            toast.success('Unidad actualizada con éxito');
        }).catch((error) => {
            console.error('Error updating storage unit: ', error);
            toast.error('Error actualizando la unidad');
        }).finally(() => setLoading(false));

    };
  
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">Editar Unidad</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
        {loading && <MiniLoadingSpinner />}
        {!loading &&
          <Form>
            <Form.Group className="mp-formgroup horizontal">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese el nombre"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
           
            <Form.Group className="mp-formgroup horizontal">
              <Form.Label>Prioridad</Form.Label>
              <Dropdown className="user-dropdown-container">
                <Dropdown.Toggle
                  variant="none"
                  className="user-dropdown"
                  id="priority-dropdown-edit"
                >
                  Prioridad {priority}
                </Dropdown.Toggle>
                <Dropdown.Menu className="user-dropdown-menu">
                  {[...Array(10)].map((_, index) => (
                    <Dropdown.Item
                      key={index + 1}
                      onClick={() => setPriority(index + 1)}
                      active={priority === index + 1}
                    >
                      <div className="user-item">
                        <FaLayerGroup size={16} />
                        <span className="user-name">Prioridad {index + 1}</span>
                      </div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>
<Form.Group className="mp-formgroup horizontal">
  <Form.Label>Unidad de Respaldo</Form.Label>
  <Dropdown className="user-dropdown-container">
    <Dropdown.Toggle
      variant="none"
      className="user-dropdown"
      id="backup-unit-dropdown-edit"
    >
      {backupUnitId
        ? units.find(u => u.storage_unit_id === backupUnitId)?.name
        : 'Ninguno'}
    </Dropdown.Toggle>
    <Dropdown.Menu className="user-dropdown-menu">
      <Dropdown.Item
        onClick={() => setBackupUnitId(null)}
        active={backupUnitId === null}
      >
        <div className="user-item">
          <FaWarehouse size={16} />
          <span className="user-name">Ninguno</span>
        </div>
      </Dropdown.Item>
      {units.map((unit) => (
        <Dropdown.Item
          key={unit.storage_unit_id}
          onClick={() => setBackupUnitId(unit.storage_unit_id)}
          active={backupUnitId === unit.storage_unit_id}
        >
          <div className="user-item">
            <FaWarehouse size={16} />
            <span className="user-name">{unit.name}</span>
          </div>
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
</Form.Group>

            <Form.Group controlId="is_default" className="mp-formgroup horizontal" style={{ alignItems: 'center' }}>
              <Form.Check
                type="checkbox"
                label="Unidad por Defecto"
                className="mediopunto-form-check-input"
                name="is_default"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="is-default-tooltip">
                    Marca esta unidad como la unidad de almacenamiento por defecto.
                  </Tooltip>
                }
              >
                <span style={{color: '#6b6b6b', cursor: 'pointer', marginLeft: '8px'}}>
                  <FaInfoCircle />
                </span>
              </OverlayTrigger>
            </Form.Group>
            <Form.Group controlId="is_global" className="mp-formgroup horizontal" style={{ alignItems: 'center' }}>
              <Form.Check
                type="checkbox"
                label="Almacenamiento Multi-Local"
                className="mediopunto-form-check-input"
                name="is_global"
                checked={isGlobal}
                onChange={(e) => setIsGlobal(e.target.checked)}
              />
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="is-global-tooltip">
                    Permite que esta unidad de almacenamiento sea utilizada en múltiples locales.
                  </Tooltip>
                }
              >
                <span style={{color: '#6b6b6b', cursor: 'pointer', marginLeft: '8px'}}>
                  <FaInfoCircle />
                </span>
              </OverlayTrigger>
            </Form.Group>
          </Form>
        }
        </Modal.Body>
        <Modal.Footer>
          <div className="form-modal-footer-custom">
            <Button variant="none" className="form-button-cancel" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="none" className="form-button-create" onClick={handleSubmit}>
              Guardar Cambios
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  export const RenderDeleteUnitModal: React.FC<ModalProps> = ({
    show,
    parentUnit,
    units,
    handleClose,
    setUnits,
  }) => {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState<any[]>([]);
    const [loadingProducts, setLoadingProducts] = useState(false);
  
    useEffect(() => {
      if (!parentUnit || !show) return;
  
      const user = JSON.parse(localStorage.getItem('user') ?? '{}');
      const localId = user ? Number(user.local_id) : 0;
  
      setLoadingProducts(true);
      getProductStockByLocalId(localId)
        .then((res) => {
          // Filtrar los productos que pertenecen a esta unidad
          const filteredProducts = res.data.filter(
            (product: any) => product.storage_unit_id === parentUnit.storage_unit_id
          );
          setProducts(filteredProducts);
        })
        .catch((error) => {
          console.error('Error fetching product stock:', error);
        })
        .finally(() => setLoadingProducts(false));
    }, [parentUnit, show]);
  
    const handleDelete = () => {
      setLoading(true);
      if (!parentUnit) return;
  
      deleteStorageUnit(parentUnit.storage_unit_id!)
        .then(() => {
          const newUnits = units.filter(
            (unit) => unit.storage_unit_id !== parentUnit.storage_unit_id
          );
          setUnits(newUnits);
          handleClose();
          toast.success('Unidad eliminada con éxito');
        })
        .catch((error) => {
          console.error('Error deleting storage unit: ', error);
          toast.error('Error eliminando la unidad');
        })
        .finally(() => setLoading(false));
    };
  
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">Eliminar Unidad</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          {loading && <MiniLoadingSpinner />}
          {!loading && (
            <div>
              <p className='itms-unit-modal-stick-title'>¿Está seguro que desea eliminar la unidad "{parentUnit?.name}"?</p>
  
              {/* Mostrar mensaje dependiendo si hay productos o no */}
              {loadingProducts ? (
                <MiniLoadingSpinner />
              ) : products.length > 0 ? (
                <div className='modal-items-unit-stock'>
                  <p className='itms-unit-modal-stick-title'>Items en la unidad. Elimina los items para poder eliminarla la unidad:</p>
                  <ul className='list-itmes-unidad-stock'>
                    {products.map((product) => (
                      <li key={product.id}>
                        {product.name} - Cantidad: {product.quantity}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className='itms-unit-modal-stick-title'>La unidad no tiene ítems relacionados a ella, puede eliminarla sin problemas.</p>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="form-modal-footer-custom">
            <Button className="form-button-cancel" onClick={handleClose}>
              Cancelar
            </Button>
            <Button className="form-button-cancel" style={{ backgroundColor: 'red'} } onClick={handleDelete} disabled={products.length > 0}>
              Eliminar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };
